import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { GoogleDialogComponent } from "src/app/components/GoogleDialog/GoogleDialog.component";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ProfileComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authSrv: AuthService
  ) {}

  ngOnInit(): void {
    this.getCurrentUser();
  }

  confirmAndLogout() {
    const dialogRef = this.dialog.open(GoogleDialogComponent, {
      data: {
        title: $localize`:@@seDeconnect:Se déconnecter`,
        msg: $localize`:@@etesVsSurDeconnect:Etes-vous sûr de vouloir vous déconnecter ?`,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.authSrv.logout();
        this.dialogRef.close();

      }
    });
  }
  getCurrentUser() {
    return this.authSrv.getCurrentUser().subscribe((user) => {
      this.data = user;
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
